import EmailStore from './emailStore'
// import AttachmentStore from './AttachmentStore'
// import UIStore from './UIStore'

class RootStore {
  emailStore = new EmailStore()
  // attachmentStore = new AttachmentStore()
  // uiStore = new UIStore()
}

export const rootStore = new RootStore()
